import { render, staticRenderFns } from "./ModuleAccess.vue?vue&type=template&id=48802cff&"
import script from "./ModuleAccess.vue?vue&type=script&lang=js&"
export * from "./ModuleAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports